<template>

    <v-modal
        :open="open"
        class="c-modal_remove_patient">
        <h2>Usuń pacjenta z bazy danych</h2>
        <p class="c-modal_remove_patient__content">Usunięcie pacjenta spowoduje także skasowanie jego wszystkich danych
            związanych z wizytami.</p>
        <p class="c-modal_remove_patient__question">Czy na pewno chcesz usunąć?</p>
        <div>
            <v-btn
                type="red-white"
                @click="cancel">
                Anuluj
            </v-btn>
            <v-btn
                type="red"
                @click="ok"
                has-loader
                :loading="isLoading">
                Tak, usuń
            </v-btn>
        </div>
    </v-modal>

</template>


<script>

import VModal from 'Components/VModal'
import VBtn from 'Components/VBtn'

export default {

    name: 'PatientRemoveModal',

    data() {
        return {
            patientId: null,
            open: false,
            isLoading: false
        }
    },

    methods: {
        cancel() {
            this.open = false
        },

        ok() {
            this.isLoading = true
            this.$store.dispatch('PATIENT_DELETE', this.patientId).then(({data}) => {
                this.isLoading = false
                this.$alert.success('Usuwanie pacjenta', data.message)
                this.open = false
                this.$emit('success')
            }).catch((error) => {
                this.isLoading = false
                this.$alert.error('Usuwanie pacjenta', error.response.data.message)
                this.open = false
                this.$emit('failure')
            })
        },
    },

    mounted() {
        this.$on('open', (id) => {
            this.patientId = id
            this.open = true
        })
    },

    beforeDestroy() {
        this.$off('open')
    },

    components: {
        VModal,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-modal_remove_patient {
    text-align: center;

    &__content {
        margin: 1.5rem 0;
    }
    &__question {
        color: $c-red;
        margin-bottom: 2rem;
    }
    button {
        margin: .5rem;
    }
}

</style>
